<!-- Shared Elegant Loader -->
<app-elegant-loader *ngIf="isLoadingUtilityConfig" [id]="'utility-config-loader'" [loadingText]="'Loading Utility Configuration'"></app-elegant-loader>

<ng-container *ngIf="!isLoadingUtilityConfig">
  <!-- Sell Permissions -->
  <section class="config-card">
    <div class="config-card__left">
      <h3 class="config-title">Sell</h3>
    </div>
    <div class="config-card__right">
      <label class="toggle">
        <input type="checkbox" [(ngModel)]="isSellEnabled" (change)="$event.stopPropagation(); saveConfiguration()" [disabled]="isSavingUtilityConfig" />
        <span class="toggle__slider"></span>
      </label>
    </div>
  </section>

  <!-- Buy Permissions -->
  <section class="config-card">
    <div class="config-card__left">
      <h3 class="config-title">Buy</h3>
    </div>
    <div class="config-card__right">
      <label class="toggle">
        <input type="checkbox" [(ngModel)]="isBuyEnabled" (change)="$event.stopPropagation(); saveConfiguration()" [disabled]="isSavingUtilityConfig" />
        <span class="toggle__slider"></span>
      </label>
    </div>
  </section>
</ng-container>